// CMS page paths for legal content.
export const AGB_PAGE_PATH = '/p/U0oFFTiyQDvK';
export const SUBSCRIPTION_AGB_PAGE_PATH = AGB_PAGE_PATH;
// Privacy policy (footer menu item path; adjust slug if needed).
export const PRIVACY_POLICY_PAGE_PATH = '/p/datenschutz';

export const WITHDRAWAL_TYPE_OPTIONS = [
  { key: '', text: '— Bitte wählen —', value: '' },
  { key: 'statutory', text: 'Gesetzliches Widerrufsrecht', value: 'statutory' },
  { key: 'contractual', text: 'Vertragliches Kündigungsrecht', value: 'contractual' },
  { key: 'other', text: 'Sonstiges', value: 'other' },
];
